var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._t("default"),_c('div',{staticClass:"overlay"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }